import PagesController from 'controllers/PagesController';
import ComponentsManager from "controllers/ComponentsManager";
import Agency from './Agency';
import AgencyHeader from "./AgencyHeader";
import AgencyAwards from "./AgencyAwards";
import TransitionAwards from "./TransitionAwards";
import AgencyIntroShapes from "./AgencyIntroShapes";
import TransitionClients from "./TransitionClients";
// import AgencyNameShapes from "./AgencyNameShapes";


export default new class {
	constructor() {
		PagesController.addPage('agency', Agency);
		ComponentsManager.register('agency_header', AgencyHeader);
		ComponentsManager.register('agency_intro_shapes', AgencyIntroShapes);
		ComponentsManager.register('agency_awards', AgencyAwards);
		ComponentsManager.register('transition_awards', TransitionAwards);
		ComponentsManager.register('transition_clients', TransitionClients);
		// ComponentsManager.register('agency_name_shapes', AgencyNameShapes);
	}
};
